import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {updateUserProfileAction, saveARequest} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import * as MainConstants from "../../utils/MainConstants";
import ReCAPTCHA from "react-google-recaptcha";
import {
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';




const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder),
    multilineColor:{
        color:'red'
    }

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    multilineColor:{
        color:'black',
        backgroundColor:'white'
    }
});


class RequestSample extends Component {

    state = {
        age: '',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{"comment":"This is a request"},
        captchaValue:"",
        apple:false,
        banana:false,
        cherry:false,
        fruit:"",
        Beginner:false,
        Casual:false,
        Experienced:false,
        A1:false,
        A3:false,
        A6:false,
        A10:false,
        Overwatering:false,
        Underwatering:false,
         Inconsistent:false,
         Messy:false,
         Root:false,
         Notsure:false,
         Other:false,
        /*
        overWateringText:"",
        underwateringText:"",
        inconsistentText:"",
        messyText:"",
        rootText:"",
        notsureText:"",
        otherText:""

         */

    };
    constructor(props) {
        super(props);

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange= this.handleEmailChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.saveVisitorComment = this.saveVisitorComment.bind(this);
        this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
        this.sanitizeInput= this.sanitizeInput.bind(this);
        this.recaptchaRef = React.createRef();
        this.handleAddressChange= this.handleAddressChange.bind(this);
        this.handlePhoneChange= this.handlePhoneChange.bind(this);
        this.handleChangeApple= this.handleChangeApple.bind(this);
        this.handleChangeBanana= this.handleChangeBanana.bind(this);
        this.handleChangeQuestion1= this.handleChangeQuestion1.bind(this);
        this.handleChangeQuestion2= this.handleChangeQuestion2.bind(this);
        this.handleChangeQuestion3= this.handleChangeQuestion3.bind(this);
        this.handleOtherResponseChange = this.handleOtherResponseChange.bind(this);
        this.handleResponse4Change = this.handleResponse4Change.bind(this);
        this.handleResponse5Change = this.handleResponse5Change.bind(this);
        this.handleResponse6Change = this.handleResponse6Change.bind(this);
        this.handleResponse7Change = this.handleResponse7Change.bind(this);
        this.overWateringText="";
        this.underwateringText="";
        this.inconsistentText="";
        this.messyText="";
        this.rootText="";
        this.notsureText="";
        this.otherText="";





    }

    handleCaptchaChange = (value) => {
        this.setState({ captchaValue: value });
    };

    componentDidMount() {
        const { isAuthenticated ,updateUserProfileAction} = this.props;
        //isAuthenticated();
        //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
        updateUserProfileAction(null, this.props.loginData.accessToken);
        //updateAuth();
        // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

    }


    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleFirstNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

        //this.setState({userComment , {{firstname:event.target.value }});
        // this.setState(Object.assign(this.state.firstname, event.target.value));
    }

    handleLastNameChange(event) {
        //event.preventDefault();
        //this.setState(Object.assign(this.state.lastname, event.target.value));
        this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

    }

    handleEmailChange(event) {
        //event.preventDefault();
        //this.setState(Object.assign(this.state.email,event.target.value));
        this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

    }

    handleAddressChange(event) {
        //event.preventDefault();
        //this.setState(Object.assign(this.state.email,event.target.value));
        this.setState(Object.assign(this.state.userComment,{address:event.target.value}));

    }

    handlePhoneChange(event) {
        //event.preventDefault();
        //this.setState(Object.assign(this.state.email,event.target.value));
        this.setState(Object.assign(this.state.userComment,{phone:event.target.value}));

    }
    handleCommentChange(event) {
        //event.preventDefault();
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{comment: sanitizedValue}));
        //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }

    handleOtherResponseChange(event) {
        //event.preventDefault();
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{otherresponse: sanitizedValue}));
        //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }
    handleResponse4Change(event) {
        //event.preventDefault();
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{response4: sanitizedValue}));
        //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }
    handleResponse5Change(event) {
        //event.preventDefault();
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{response5: sanitizedValue}));
        //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }
    handleResponse6Change(event) {
        //event.preventDefault();
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{response6: sanitizedValue}));
        //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }

    handleResponse7Change(event) {
        //event.preventDefault();
        let sanitizedValue = this.sanitizeInput(event.target.value);
        this.setState(Object.assign(this.state.userComment,{response7: sanitizedValue}));
        //this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }





    saveVisitorComment(event ){
        const {saveARequest} = this.props;
        var  returnString="";
        var tempLastName =  this.state.userComment.lastname;
        var tempFirstName = this.state.userComment.firstname;
        var tempEmail = this.state.userComment.email;
        var tempComment = "This is a request";//this.state.userComment.comment;
        var tempAddress = this.state.userComment.address;
        var tempPhone = this.state.userComment.phone;


        if((tempFirstName == null) || (tempFirstName.length == 0)){
            alert("Please provide your first name!");
        }else {

            if ((tempLastName == null) || (tempLastName.length == 0)) {
                alert("Please provide your last name!");
            }else {
                if ((tempAddress == null) || (tempAddress.length == 0)) {
                    alert("Please provide your Address!");
                }else {
                    if ((tempPhone == null) || (tempPhone.length == 0)) {
                        alert("Please provide your phone!");
                    } else {

                        if ((tempEmail == null) || (tempEmail.length == 0)) {
                            alert("Please provide your Email!");
                        } else {

                            if ((tempEmail.indexOf("@") == -1)) {
                                alert("Please provide proper Email address!");
                            } else {
                                if ((tempComment == null) || (tempComment.length == 0)) {
                                    alert("Please provide your comment!");
                                } else {
                                    //Here send the data to the back end.

                                    if ((this.state.Beginner === false) && (this.state.Casual === false) && (this.state.Experienced === false)) {
                                        alert("Please provide your response to question 1");
                                    } else {
                                        if ((this.state.A1 === false) && (this.state.A3 === false) && (this.state.A6 === false) && (this.state.A10 === false)) {
                                            alert("Please provide your response to question 2");
                                        } else {
                                            if ((this.state.Overwatering === false) && (this.state.Underwatering === false) && (this.state.Inconsistent === false) && (this.state.Messy === false) &&
                                            (this.state.Root === false) && (this.state.Notsure === false) && (this.state.Other === false)
                                            ) {
                                                alert("Please provide your response to question 3");
                                            } else {
                                                if ((this.state.userComment.response4 === undefined) || (this.state.userComment.response4.length === 0)) {
                                                    alert("Please provide your response to question 4");
                                                } else {
                                                    if ((this.state.userComment.response5 === undefined) || (this.state.userComment.response5.length === 0)) {
                                                        alert("Please provide your response to question 5");
                                                    } else {
                                                        if ((this.state.userComment.response6 === undefined) || (this.state.userComment.response6.length === 0)) {
                                                            alert("Please provide your response to question 6");
                                                        } else {
                                                            if ((this.state.userComment.response7 === undefined) || (this.state.userComment.response7.length === 0)) {
                                                                alert("Please provide your response to question 7");
                                                            } else {
                                                                if( ( this.state.Other === true) && ((this.state.userComment.otherresponse === undefined) || (this.state.userComment.otherresponse.length === 0))) {
                                                                    alert("Please provide your response for {Other} on question 3");
                                                                } else
                                                                {

                                                                    if (typeof this.state.captchaValue === "string" && this.state.captchaValue.length > 0) {
                                                                        console.log("captchaValue =", this.state.captchaValue);
                                                                        console.log("typeof captchaValue =", typeof this.state.captchaValue);

                                                                        saveARequest(
                                                                            this.state.userComment,
                                                                            this.state.captchaValue
                                                                        );

                                                                        this.recaptchaRef.current.reset();
                                                                    } else {
                                                                        console.log("Invalid captchaValue:", this.state.captchaValue);
                                                                        console.log("typeof captchaValue:", typeof this.state.captchaValue);
                                                                        alert("Please make sure the reCAPTCHA is complete");
                                                                    }


                                                                    /*
                                                                    if (this.state.captchaValue) {

                                                                        saveARequest(DEFAULT_VESPAAN_SERVER.url, this.state.userComment, this.state.captchaValue);
                                                                        // To reset reCAPTCHA manually
                                                                        this.recaptchaRef.current.reset();
                                                                    } else {
                                                                        // Handle case where reCAPTCHA is not solved
                                                                        console.log('Please complete the reCAPTCHA');
                                                                        alert('Please make sure the reCAPTCHA is complete');
                                                                        //9-30-2025 Remove This. I added this for testing only.
                                                                        //saveARequest(DEFAULT_VESPAAN_SERVER.url, this.state.userComment, this.state.captchaValue);
                                                                    }

                                                                     */
                                                                }

                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                }
                            }
                        }
                    }
                }
            }
        }

        return returnString;
    }
    /* saveVisitorComment(){
         const {saveAComment} = this.props;
         var  returnString="";
        var tempLastName =  this.state.userComment.lastname;
        var tempFirstName = this.state.userComment.firstname;
        var tempEmail = this.state.userComment.email;
        var tempComment = this.state.userComment.comment;


         if((tempFirstName == null) || (tempFirstName.length == 0)){
             alert("Please provide your first name!");
         }else {

             if ((tempLastName == null) || (tempLastName.length == 0)) {
                 alert("Please provide your last name!");
             }else {

                 if ((tempEmail == null) || (tempEmail.length == 0)) {
                     alert("Please provide your Email!");
                 } else {

                     if ((tempEmail.indexOf("@") == -1)) {
                         alert("Please provide proper Email address!");
                     }else{
                         if ((tempComment == null) || (tempComment.length == 0)) {
                             alert("Please provide your comment!");
                         }else{
                             //Here send the data to the back end.
                             saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

                         }
                     }
                 }
             }
         }

         return returnString;
     } */
    /* Orignal which was for testing teh login.
    saveVisitorComment(){
        const { isAuthenticated ,updateUserProfileAction} = this.props;
        //isAuthenticated();
        //updateUserProfileAction();
        updateUserProfileAction(null, this.props.loginData.accessToken);
        let returnString ="not defined";

        if(this.props.userProfile !== undefined){
            returnString= this.props.userProfile.sub;
        }

        let returnString2 ="not defined 2";

        if(this.props.userProfile !== undefined){
            returnString2= this.props.userProfile.nickname;
        }
        alert("hey farshid I  got " +returnString+returnString2);
        return returnString;
    } */

    sanitizeInput(value){
        let div1 = document.createElement('div');
        div1.textContent = value;
        return div1.innerHTML;
    };

    handleChangeQuestion1 (event) {
        //this.setState({apple:event.target.checked});
        this.setState({Beginner:false});
        this.setState({Casual:false});
        this.setState({Experienced:false});
        if(event.target.name === "Beginner"){
            this.setState({Beginner:event.target.checked});
        }else if(event.target.name === "Casual"){
            this.setState({Casual:event.target.checked});
        } else if(event.target.name === "Experienced"){
            this.setState({Experienced:event.target.checked});
        }
        let tempResponse= event.target.name;
        console.log("tempResponse  = "+  tempResponse);
        this.setState(Object.assign(this.state.userComment,{q1a:tempResponse}));
    };
    handleChangeQuestion2 (event) {
        this.setState({A1:false});
        this.setState({A3:false});
        this.setState({A6:false});
        this.setState({A10:false});
        let question2Resp = "";
        if(event.target.name === "A1"){
            this.setState({A1:event.target.checked});
            question2Resp="1-2";
        }else if(event.target.name === "A3"){
            this.setState({A3:event.target.checked});
            question2Resp="3-5";
        } else if(event.target.name === "A6"){
            this.setState({A6:event.target.checked});
            question2Resp="6-10";
        }else if(event.target.name === "A10"){
            this.setState({A10:event.target.checked});
            question2Resp="10+";
        }
        //let tempResponse= event.target.name;
        console.log("tempResponse  = "+  question2Resp);
        this.setState(Object.assign(this.state.userComment,{q2a:question2Resp}));
    };
    handleChangeQuestion3 (event) {



        console.log("Target Name is " + event.target.name + " and event checked is " + event.target.checked );
        if(event.target.name === "Overwatering"){
            this.setState({Overwatering:event.target.checked});
            if(event.target.checked === true){
                //overWateringText=  event.target.name;
                //this.setState({overWateringText:event.target.name});
                this.overWateringText=event.target.name;
            }else{
                //overWateringText="";
                //this.setState({overWateringText:""});
                this.overWateringText="";
            }
        }
        if(event.target.name === "Underwatering"){
            this.setState({Underwatering:event.target.checked});
            if(event.target.checked === true){
                //underwateringText=  event.target.name;
                //this.setState({underwateringText:event.target.name});
                this.underwateringText=event.target.name;
            }else{
                //underwateringText="";
                //this.setState({underwateringText:""});
                this.underwateringText="";
            }
        } if(event.target.name === "Inconsistent"){
            this.setState({Inconsistent:event.target.checked});
            if(event.target.checked === true){
                //inconsistentText=  event.target.name;
               // this.setState({inconsistentText:event.target.name});
                this.inconsistentText=event.target.name;
            }else{
                //inconsistentText="";
                //this.setState({inconsistentText:""});
                this.inconsistentText="";
            }
        }if(event.target.name === "Messy"){
            this.setState({Messy:event.target.checked});
            if(event.target.checked === true){
                //messyText=  event.target.name;
                //this.setState({messyText:event.target.name});
                this.messyText=event.target.name;
            }else{
                //messyText="";
                //this.setState({messyText:""});
                this.messyText="";
            }
        }if(event.target.name === "Root"){
            this.setState({Root:event.target.checked});
            if(event.target.checked === true){
                //rootText=  event.target.name;
                //this.setState({rootText:event.target.name});
                this.rootText=event.target.name;
            }else{
                //rootText="";
                //this.setState({rootText:""});
                this.rootText="";
            }
        } if(event.target.name === "Notsure"){
            this.setState({Notsure:event.target.checked});
            if(event.target.checked === true){
                //notsureText=  event.target.name;
                //this.setState({notsureText:event.target.name});
                this.notsureText=event.target.name;
            }else{
                //notsureText="";
                //this.setState({notsureText:""});
                this.notsureText="";
            }
        }if(event.target.name === "Other"){
            this.setState({Other:event.target.checked});
            if(event.target.checked === true){
                //otherText=  event.target.name;
                //this.setState({otherText:event.target.name});
                this.otherText=event.target.name;
            }else{
                //otherText="";
                //this.setState({otherText:""});
                this.otherText="";
            }
        }
        //let tempResponse= event.target.name;
        /*let tempResponse=  this.state.overWateringText+ "--"+
            this.state.underwateringText+ "--"+
            this.state.inconsistentText+ "--"+
            this.state.messyText+ "--"+
            this.state.rootText+ "--"+
            this.state.notsureText+ "--"+
            this.state.otherText+ "--";*/

        let tempResponse=  this.overWateringText+ "--"+
            this.underwateringText+ "--"+
            this.inconsistentText+ "--"+
            this.messyText+ "--"+
            this.rootText+ "--"+
            this.notsureText+ "--"+
            this.otherText+ "--";
        console.log("tempResponse  = "+  tempResponse);
        this.setState(Object.assign(this.state.userComment,{q3a:tempResponse}));
    };
    handleChangeApple (event) {
        //console.log("Handle change is called");
        //console.log(event);
        console.log("Handle change is called Apple");
        console.log(event);
        console.log(event.target.id);
        this.setState({apple:event.target.checked});
        this.setState({banana:false});
        // this.setState({apple:event.target.value});
    };
    handleChangeBanana (event) {
        console.log("Handle change is called Banana");

        console.log(event.target.value);
        console.log(event);
        console.log(event.target.id);
        this.setState({banana:event.target.checked});
        this.setState({apple:false});
        //this.setState({fruit:event.target.value});
        // this.setState({apple:event.target.value});
    };

    render() {
        const { classes } = this.props;
        return (
            <div id="contactus" style={{  backgroundColor:"#F2F6F8"  }}>

                <Grid container spacing={24}   style={{  }}     >

                    <Grid   item xs={12} sm={12}    style={{   }}   >

                        <div  style = {{   backgroundPosition:'center',   paddingTop:50,   paddingRight:10, paddingLeft:30}}  >

                            <Typography  variant="h3"   style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C'}} >
                                Request {MainConstants.APPLICATION_NAME}&trade; Sample
                            </Typography>
                            <Typography  variant="h5"   style = { { textAlign: 'center', alignSelf: 'center'  ,    color:'red'}}>
                                ______________________
                            </Typography>

                            <Grid container spacing={24} style = { {   textAlign: 'center', alignSelf: 'center' }}>

                                {/*} <Grid   item xs={12} sm={12} md={4}  lg={4} xl={4}>
                                    <Typography  variant="subtitle1"  style = { { paddingTop:20}}>
                                                            <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                    {MainConstants.APPLICATION_NAME}&trade;, Where Orchids Flourish, Effortlessly!


                                                                </span>


                                    </Typography>



                                    <Typography  variant="subtitle1">
                                                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black'}}>
                                                                    __________________
                                                                    </span>
                                    </Typography>








                                </Grid> */}
                                <Grid   item xs={1} sm={1} md={1}  lg={1} xl={1}>
                                </Grid>
                                <Grid   item xs={12} sm={12} md={11}  lg={11} xl={11}   >
                                    <div style = { { textAlign: 'center', alignSelf:'center' , borderRadius:'0',
                                        borderLeftColor: 'red',
                                        backgroundColor:'transparent',color:'black', borderSize:'2',borderRadius:'0', bordered:'true'
                                        , fontSize:20}}>
                                        <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                            <span style = { { textAlign: 'center', alignSelf: 'center' , fontSize:24, color:'black'}}>
                                               We’re currently working with a small group of early users to test Orchima™ (Patent Pending) and gather feedback.
                                                If you’re interested in participating,
                                                please complete the form below. Selected participants
                                                will be invited from among those who submit the form.
                                            </span>
                                        </Typography>
                                        <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                            <span style = { { textAlign: 'center', alignSelf: 'center' , fontSize:24, color:'black'}}>
                                               Please fill out and submit the form below.
                                            </span>
                                        </Typography>


                                        <Grid container spacing={8} style = { { textAlign: 'center', alignSelf: 'center' ,backgroundColor:'transparent'}}>


                                            <Grid   item xs={6} sm={6}    >

                                                <TextField   variant="filled"  style = { { textAlign: 'center', marginLeft:10,  marginTop:20, alignSelf:'center', color:'white', fontSize:16}} required id="Description-fn" name="firstname"  label="First Name"  fullWidth  InputProps={{ classes: {input: classes.multilineColor } }}  value={this.state.userComment.firstname} onChange={this.handleFirstNameChange}/>
                                            </Grid>
                                            <Grid   item xs={6} sm={6}    >
                                                <TextField  variant="filled"  style = { { textAlign: 'center',    alignSelf:'center', marginLeft:5, marginTop:20, marginRight:10,  color:'white', fontSize:16}} required id="DisplayName" name="lastname"  label="Last Name"  fullWidth   value={this.state.userComment.lastname} InputProps={{ classes: {input: classes.multilineColor } }} onChange={this.handleLastNameChange}/>
                                            </Grid>

                                            <Grid   item xs={12} sm={12}    >
                                                <TextField    variant="filled"  style = { { textAlign: 'center', marginLeft:5,  alignSelf: 'center', color:'white', marginRight:10,  fontSize:16}} required id="Description-email" name="email"  label="Email"  fullWidth    value={this.state.userComment.email} InputProps={{ classes: {input: classes.multilineColor } }} onChange={this.handleEmailChange}/>
                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                                <TextField    variant="filled"  style = { { textAlign: 'center', marginLeft:5,  alignSelf: 'center', color:'white', marginRight:10,  fontSize:16}} required id="Description-address" name="address"  label="Full Address"  fullWidth    value={this.state.userComment.address} InputProps={{ classes: {input: classes.multilineColor } }} onChange={this.handleAddressChange}/>
                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                                <TextField    variant="filled"  style = { { textAlign: 'center', marginLeft:5,  alignSelf: 'center', color:'white', marginRight:10,  fontSize:16}} required id="Description-phone" name="phone"  label="phone"  fullWidth    value={this.state.userComment.phone} InputProps={{ classes: {input: classes.multilineColor } }} onChange={this.handlePhoneChange}/>
                                            </Grid>
                                            {/*<Grid   item xs={12} sm={12}    >
                                                <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}    className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="comment" name="comment"  label="Comment"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.comment} onChange={this.handleCommentChange}/>


                                            </Grid>*/}
                                            <Grid   item xs={12} sm={12}    >
                                            <div style = { { marginLeft:10, textAlign: 'left', alignSelf: 'center' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                1 - How would describe your Orchid experience?
                                                </span>
                                                </Typography>
                                                <FormControl component="fieldset" style = { { marginLeft:10, textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black', display:'flex'}}>
                                                    {/*<FormLabel component="legend">Select One</FormLabel> */}
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Beginner} onChange={this.handleChangeQuestion1} name="Beginner" />}
                                                            label="Beginner (just starting)"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Casual} onChange={this.handleChangeQuestion1} name="Casual" />}
                                                            label="Casual grower (a few orchids)"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Experienced} onChange={this.handleChangeQuestion1} name="Experienced" />}
                                                            label="Experienced grower"
                                                        />

                                                    </FormGroup>
                                                </FormControl>
                                            </div>
                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                            <div style = { {marginLeft:10,  textAlign: 'left', alignSelf: 'center' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                2 - How many orchids do you currently have?
                                                </span>
                                                </Typography>
                                                <FormControl component="fieldset" style = { { marginLeft:10, textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black', display:'flex'}}>
                                                    {/*<FormLabel component="legend">Select One</FormLabel> */}
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.A1} onChange={this.handleChangeQuestion2} name="A1" />}
                                                            label="1-2"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.A3} onChange={this.handleChangeQuestion2} name="A3" />}
                                                            label="3-5"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.A6} onChange={this.handleChangeQuestion2} name="A6" />}
                                                            label="6-10"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.A10} onChange={this.handleChangeQuestion2} name="A10" />}
                                                            label="10+"
                                                        />

                                                    </FormGroup>
                                                </FormControl>
                                            </div>
                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                            <div style = { { marginLeft:10, textAlign: 'left', alignSelf: 'center' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                3 - What challenges do you face with orchid care? Select all that apply (you may choose more than one)
                                                </span>
                                                </Typography>
                                                <FormControl component="fieldset" style = { { marginLeft:10, textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black', display:'flex'}}>
                                                    {/*<FormLabel component="legend">Select One</FormLabel> */}
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Overwatering} onChange={this.handleChangeQuestion3} name="Overwatering" />}
                                                            label="Overwatering"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Underwatering} onChange={this.handleChangeQuestion3} name="Underwatering" />}
                                                            label="Underwatering"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Inconsistent} onChange={this.handleChangeQuestion3} name="Inconsistent" />}
                                                            label="Inconsistent routine"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Messy} onChange={this.handleChangeQuestion3} name="Messy" />}
                                                            label="Messy watering process"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Root} onChange={this.handleChangeQuestion3} name="Root" />}
                                                            label="Root health issues"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Notsure} onChange={this.handleChangeQuestion3} name="Notsure" />}
                                                            label="Not sure what I’m doing"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={this.state.Other} onChange={this.handleChangeQuestion3} name="Other" />}
                                                            label="Other"
                                                        />

                                                    </FormGroup>
                                                </FormControl>
                                                { (this.state.Other == true ) && (
                                                <Grid   item xs={10} sm={10}    >
                                                    <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}     inputProps={{ maxLength:500 }} className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="otherresponse" name="otherresponse"  label="Other Response"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.otherresponse} onChange={this.handleOtherResponseChange}/>
                                                </Grid>
                                                )}
                                                {( this.state.userComment.otherresponse !== undefined ) && (
                                                    <Typography  variant="subtitle1" style = { { paddingTop:10}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:16, color:'black'}}>
                                                {500-this.state.userComment.otherresponse.length}/500
                                                </span>
                                                    </Typography>)}

                                            </div>
                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                            <div style = { {marginLeft:10, textAlign: 'left', alignSelf: 'center' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                4 - Why are you interested in Orchima™?
                                                </span>
                                                </Typography>
                                                <Grid   item xs={10} sm={10}    >
                                                    <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}   inputProps={{ maxLength:500 }}  className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="comment" name="comment"  label="Answer 4"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.response4} onChange={this.handleResponse4Change}/>

                                                </Grid>
                                                {( this.state.userComment.response4 !== undefined ) && (
                                                    <Typography  variant="subtitle1" style = { { paddingTop:10}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:16, color:'black'}}>
                                                {500-this.state.userComment.response4.length}/500
                                                </span>
                                                    </Typography>)}
                                            </div>
                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                            <div style = { { marginLeft:10, textAlign: 'left', alignSelf: 'left' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                5 - Would you be willing to provide feedback after using the product?
                                                </span>
                                                </Typography>
                                                <Grid   item xs={10} sm={10}    >
                                                    <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}   inputProps={{ maxLength:500 }} className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="comment" name="comment"  label="Answer 5"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.response5} onChange={this.handleResponse5Change}/>

                                                </Grid>
                                                {( this.state.userComment.response5 !== undefined ) && (
                                                    <Typography  variant="subtitle1" style = { { paddingTop:10}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:16, color:'black'}}>
                                                {500-this.state.userComment.response5.length}/500
                                                </span>
                                                    </Typography>)}
                                            </div>

                                            </Grid>
                                            <Grid   item xs={12} sm={12}    >
                                            <div style = { { marginLeft:10,textAlign: 'left', alignSelf: 'center' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                6 - Please share with us if you are part of any orchid society or plant group.
                                                </span>
                                                </Typography>
                                                <Grid   item xs={10} sm={10}    >
                                                    <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}   inputProps={{ maxLength:500 }} className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="comment" name="comment"  label="Answer 6"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.response6} onChange={this.handleResponse6Change}/>
                                                </Grid>
                                                {( this.state.userComment.response6 !== undefined ) && (
                                                <Typography  variant="subtitle1" style = { { paddingTop:10}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:16, color:'black'}}>
                                                {500-this.state.userComment.response6.length}/500
                                                </span>
                                                </Typography>)}
                                            </div>
                                            </Grid>


                                            <Grid   item xs={12} sm={12}    >
                                                <div style = { { marginLeft:10,textAlign: 'left', alignSelf: 'center' , fontSize:26, color:'black', flexDirection:"row"}}>
                                                    <Typography  variant="subtitle1" style = { { paddingTop:20}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:22, color:'black'}}>
                                                7 - We’d love to hear any additional thoughts you may have about orchids, Orchima™, or orchid care in general.
                                                </span>
                                                    </Typography>
                                                    <Grid   item xs={10} sm={10}    >
                                                        <TextField   rowsMax="6" rows="6" variant="filled"   multiline={true}  inputProps={{ maxLength:500 }}   className={classes.textField} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:20 , color:'white', fontSize:16}} required id="comment" name="comment"  label="Answer 7"  fullWidth    InputProps={{ classes: {input: classes.multilineColor } }} value={this.state.userComment.response7} onChange={this.handleResponse7Change}/>
                                                    </Grid>
                                                    {( this.state.userComment.response7 !== undefined ) && (
                                                        <Typography  variant="subtitle1" style = { { paddingTop:10}}>
                                                <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:16, color:'black'}}>
                                                {500-this.state.userComment.response7.length}/500
                                                </span>
                                                        </Typography>)}
                                                </div>
                                            </Grid>



                                            <Grid   item xs={12} sm={12}>
                                                <div>
                                                    <ReCAPTCHA
                                                        sitekey={MainConstants.RECAPTCHASITEKEY}
                                                        size="normal"
                                                        ref={this.recaptchaRef}
                                                        onChange={this.handleCaptchaChange}
                                                        style={{ display:'flex', marginBottom:1, marginTop:2, justifyContent:'center', alignItems:'center' }}
                                                    />

                                                    <Button
                                                        size="large"
                                                        type="button"
                                                        variant="contained"
                                                        onClick={this.saveVisitorComment}
                                                        style={{ backgroundColor:'#D4E0EA', fontSize:20, color:'black', border:'2px solid black', borderRadius:5, textTransform:'none', width:'50%' }}
                                                    >
                                                        Submit Request Form
                                                    </Button>
                                                </div>
                                                {/*<div  >
                                                    <form onSubmit={this.saveVisitorComment}>

                                                        <ReCAPTCHA
                                                            //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                                                            sitekey={MainConstants.RECAPTCHASITEKEY }
                                                            size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                                                            ref={this.recaptchaRef}
                                                            onChange={this.handleCaptchaChange}
                                                            badge="bottomright" // Adjust badge position as needed
                                                            style = {{  display:'flex', marginBottom:1, marginTop:2, justifyContent:'center',  alignItems: 'center', }}  />
                                                        <Button size="large"  type="submit" variant="contained"   style = { { backgroundColor:'#D4E0EA',fontSize:20, color:'black' ,border: '2px solid', borderSize:5,   borderRadius:5, bordered:'true', borderColor:'black', textTransform:'none', width:'50%'}} >Submit</Button>

                                                    </form>
                                                </div>*/}
                                                <br/>
                                                <a href="/Home"   rel="noreferrer">
                                                    <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                                                        Back to Orchima Home
                                                    </Typography>
                                                </a>
                                                <br/>
                                            </Grid>

                                        </Grid>



                                    </div>

                                </Grid>
                                <Grid   item xs={1} sm={1} md={1}  lg={1} xl={1}>
                                </Grid>
                                {/*}
                                                                <Grid   item xs={1} sm={1} md={1}  lg={1} xl={1} >
                                                                    </Grid>
                                                                    */}


                            </Grid>



                        </div>

                    </Grid>
                    <Grid   item xs={12} sm={12}    style={{   }}   >
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <Typography component="h2" variant="body1" style = { { color:'gray'}} >
                                © 2025 Vespaan Inc. — Orchima™ (Patent Pending). All rights reserved.
                            </Typography>
                            <a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                                    Privacy Policy
                                </Typography>
                            </a>
                        </div>
                    </Grid>



                </Grid>
            </div>


        );
    }
}

RequestSample.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        isAuthenticatedBool: state.login.isAuthenticatedBool,
        userProfile: state.login.userProfile,
        loginData:state.login.loginData,

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        //login:login,
        //handleAuthentication:handleAuthentication,
        //isAuthenticated:isAuthenticated,
        updateUserProfileAction:updateUserProfileAction,
        //saveAComment:saveAComment,
        saveARequest:saveARequest,
        //updateAuth:updateAuth,

    }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RequestSample));

